export default __webpack_public_path__ + "static/media/12-5.4eb40291.png";